/**
*
* Welcome
*
*/

import React from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { selectCurrentMe } from 'data/CurrentUser/selectors';
import meShape from 'Workspace/types/me';
import messages from './messages';

import {
  WelcomeMessage,
} from './styles';

export function Welcome({ me }) {
  const today = new Date();
  const currentHour = today.getHours();
  let greeting = 'goodEvening';
  if (currentHour < 12) {
    greeting = 'goodMorning';
  } else if (currentHour < 18) {
    greeting = 'goodAfternoon';
  }

  return (
    <WelcomeMessage>
      { me && me.givenName &&
        <FormattedMessage
          {...messages[greeting]}
          values={{
            name: me.givenName,
          }}
        />
      }
    </WelcomeMessage>
  );
}

Welcome.propTypes = {
  me: meShape,
};

const mapStateToProps = (state) => {
  const me = selectCurrentMe(state);
  return {
    me,
  };
};

export default connect(mapStateToProps)(Welcome);
